module.exports = __webpack_public_path__ + "static/media/canvas-flogo.374186e1.png";